// import _ from 'underscore'
import httpClient from '@src/services/http.service'
import {getSavedState, saveState} from '@state/helpers'

const likedAttractionsStorageKey = 'likedAttractions'
const likedbyAttraction = 'likedbyAttraction'
const attractionsView = 'attractionsView'
const areaFilter = 'areaFilter'
const areaOrder = 'areaOrder'

export const state = {
  attractions: [],
  topAttractions: [],
  filteredAttractions: [],
  likedAttractions: [],
  likedBy: '',
  attractionsView: '',
  areaFilter: '',
  areaOrder: '',
  error: '',
  isLoading: false,
  attractionsToDisplay: 15,
}

export const actions = {
  init: ({ commit }) => {
    if (localStorage.getItem(likedAttractionsStorageKey)) {
      commit('SET_LIKED_ATTRACTIONS', getSavedState(likedAttractionsStorageKey))
    } else {
      saveState(likedAttractionsStorageKey, [])
    }

    if (localStorage.getItem(likedbyAttraction)) {
      commit('SET_LIKED_BY', getSavedState(likedbyAttraction))
    } else {
      saveState(likedbyAttraction, '')
    }

    if (localStorage.getItem(attractionsView)) {
      commit('SET_ATTRACTION_VIEW', getSavedState(attractionsView))
    } else {
      saveState(attractionsView, 'AttractionsGrid')
    }

    if (localStorage.getItem(areaFilter)) {
      commit('SET_AREA_FILTER', getSavedState(areaFilter))
    } else {
      saveState(areaFilter, 'all')
      commit('SET_AREA_FILTER', getSavedState(areaFilter))
    }

    if (localStorage.getItem(areaOrder)) {
      commit('SET_ORDERING', getSavedState(areaOrder))
    } else {
      saveState(areaOrder, 'popularity')
      commit('SET_ORDERING', getSavedState(areaOrder))
    }
  },
  fetchAttractions: ({ commit }) => {
    commit('loadingState', { isLoading: true })
    httpClient.get('object/attraction/')
    .then(response => {
      commit('SET_ATTRACTIONS', response.data)
      commit('loadingState', { isLoading: false })
    })
    .catch(error => {
      commit('SET_ERROR', error.message)
    })
  },
  fetchTopAttractions: ({ commit }) => {
    httpClient.get('object/attraction/top-attractions')
    .then(response => {
      commit('SET_TOP_ATTRACTIONS', response.data)
    })
    .catch(error => {
      commit('SET_ERROR', error.message)
    })
  },
}

export const mutations = {
  SET_ATTRACTIONS: (state, attractions) => {
    state.attractions = attractions
    state.filteredAttractions = attractions
  },

  SET_TOP_ATTRACTIONS: (state, attractions) => {
    state.topAttractions = attractions
  },

  SET_ERROR: (state, error) => {
    state.error = error
  },

  SET_ATTRACTIONS_TO_DISPLAY: (state, count) => {
    state.attractionsToDisplay = count
  },

  SET_LIKED_ATTRACTIONS: (state, attractions) => {
    state.likedAttractions = attractions
  },

  SET_LIKED_BY: (state, attraction) => {
    state.likedBy = attraction
    saveState(likedbyAttraction, attraction)
  },

  SET_ATTRACTION_VIEW: (state, view) => {
    state.attractionsView = view
    saveState(attractionsView, view)
  },

  SET_AREA_FILTER: (state, filter) => {
    state.areaFilter = filter
    saveState(areaFilter, filter)
  },

  SET_ORDERING: (state, order) => {
    state.areaOrder = order
    saveState(areaOrder, order)
  },

  LIKE_ATTRACTION: (state, attractionId) => {
    state.likedAttractions.push(attractionId)
    saveState(likedAttractionsStorageKey, state.likedAttractions)
  },

  LIKE_GROUP: (state, group) => {
    state.likedAttractions = state.likedAttractions.concat(group)
    saveState(likedAttractionsStorageKey, state.likedAttractions)
    saveState(likedbyAttraction, state.likedBy)
  },

  REMOVE_LIKE: (state, attractionId) => {
    const idx = state.likedAttractions.indexOf(attractionId)
    state.likedAttractions.splice(idx, 1)
    saveState(likedAttractionsStorageKey, state.likedAttractions)
  },

  REMOVE_GROUP: (state, group) => {
    const filteredList = state.likedAttractions.filter(attractionId => {
      return !group.includes(attractionId)
    })
    state.likedAttractions = filteredList
    state.likedBy = ''
    saveState(likedAttractionsStorageKey, state.likedAttractions)
    saveState(likedbyAttraction, '')
  },

  SET_FILTERED_ATTRACTIONS: (state, attractions) => {
    state.filteredAttractions = attractions
  },

  CLEAR_ALL_LIKED_ATTRACTIONS: (state) => {
    state.likedAttractions = []
    saveState(likedAttractionsStorageKey, state.likedAttractions)
  },

  loadingState: (state, { isLoading }) => {
    state.isLoading = isLoading
  }
}

export const getters = {
  attractions: state => state.attractions.filter(attraction => attraction.status === 'published'),

  topAttractions: state => state.topAttractions,

  likedAttractionsIds: state => state.likedAttractions,

  likedBy: state => state.likedBy,

  currentAttractionsView: state => state.attractionsView,

  searchRegion: state => state.areaFilter,

  attractionsOrdering: state => state.areaOrder,

  likedAttractions: state => state.likedAttractions.map(attractionId => {
    return state.attractions.find(attraction => attraction._id === attractionId)
  }),

  freeEntryAttractions: state => state.attractions.filter(attraction => attraction.typology === 'pc_free_entry'),

  getAttraction: state => slug => state.attractions.find(attraction => attraction.slug === slug),

  getAttractionId: state => id => state.attractions.find(attraction => attraction._id === id),

  nearbyAttractions: state => attraction => {
    return state.attractions.filter(obj => {
      return attraction.objectsNearby.includes(obj._id)
    })
  },

  filteredAttractions: state => state.filteredAttractions.filter(attraction => attraction.typology !== 'pc_free_entry'),

  similarAttractions: state => attraction => {
   return state.attractions.filter(obj => {
      return attraction.objectsSimilar.includes(obj._id)
    })
  },

  aisLoading: state => state.isLoading,
  attractionsToDisplay: state => state.attractionsToDisplay
}

export default {
  state,
  getters,
  actions,
  mutations
}
